// extracted by mini-css-extract-plugin
export default {"expandingAreaWrapper":"_ea633ddf"};